<template>
    <div id="announcement">
        <div style="display:flex; justify-content: space-between; flex-wrap: wrap">
            <div class="item">
                <div class="header">
                    <div class="title">
                        道路运输车辆综合性能检测联网技术要求（暂行）
                    </div>
                    <div class="tip">
                        Technical Requirements for networking system of Multiple-function Detection for Road Transport Vehicles
                    </div>
                </div>
                <div class="body" style="text-align: left;">
                    <div style="width: 100%; text-align:center;">前 言</div>
                    &emsp;&emsp;为提升道路运输车辆综合性能检测的服务能力和水平，结合我国“互联网＋”发展趋势，交通运输部组织建设全国道路运输车辆综合性能检测联网
                    系统，并依托全国道路运政管理信息系统，开展部、省（地市）级综合性能检测联网系统建设，采用统一标准协议与检测机构进行数据对接，构建“开
                    放共享、互联互通、统一规范、便民利民”的道路运输车辆综合性能检测联网服务体系。<br/>
                    本技术要求用于指导和规范部、省（地市）级综合性能检测联网系统建 设，以及各级系统的互联互通、数据对接。<br/>
                    本技术要求为首次编写，由中国交通通信信息中心负责编制。
                </div>
                <a class="download" target="_blank" href="http://www.qichezongjian.com/detect/admin/downloadAnnouncement?announcementId=4">
                    <div @mouseover="showDownload">
                        <i class="el-icon-download el-icon"></i>
                    </div>
                </a>
            </div>
            <div class="item">
                <div class="header">
                    <div class="title red">
                        内蒙古自治区交通运输管理局文件
                    </div>
                    <div class="tip">
                        内交管发【2018】186号文件
                    </div>
                </div>
                <div class="body">
                    <div style="text-align: center; margin-bottom: 30px;">内蒙古自治区交通运输管理局关于货运车辆技术等级评定联网查询及异地检测等有关事宜的通知</div>
                    <b>一、 货运车辆“两检合一”后综检检验检测项目及技术等级评定要求</b><br/><br/>
                    <b style="margin-top: 10px">二、 货运车辆综检联网上传数据、工位检测照片上传及技术档案上传相关要求</b>
                </div>
                <a class="download" target="_blank" href="http://www.qichezongjian.com/detect/admin/downloadAnnouncement?announcementId=1">
                    <div @mouseover="showDownload">
                        <i class="el-icon-download el-icon"></i>
                    </div>
                </a>
            </div>
            <div class="item">
                <div class="header">
                    <div class="title red">
                        内蒙古自治区交通运输管理局文件
                    </div>
                    <div class="tip">
                        内交管发【2018】187号文件
                    </div>
                </div>
                <div class="body">
                    <div style="text-align: center; margin-bottom: 30px">内蒙古自治区交通运输管理局关于道路旅客运输等营运车辆技术等级评定联网查询等有关事宜的通知</div>
                    <b>一、 道路旅客、危险品运输车辆及出租车、教练车技术等级评定及联网查询要求</b><br/><br/>
                    <b>二、 道路旅客、危险品运输车辆及出租车、教练车技术等级评定数据、工位检测照片上传及评定技术档案相关要求</b><br/><br/>
                    <b>三、 查询方式</b>
                </div>
                <a class="download" target="_blank" href="http://www.qichezongjian.com/detect/admin/downloadAnnouncement?announcementId=2">
                    <div @mouseover="showDownload">
                        <i class="el-icon-download el-icon"></i>
                    </div>
                </a>
            </div>
            <div class="item">
                <div class="header">
                    <div class="title red">
                        内蒙古自治区交通运输厅文件
                    </div>
                    <div class="tip">
                        内交发【2018】785号文件
                    </div>
                </div>
                <div class="body">
                    <div style="text-align: center; margin-bottom: 30px">
                        内蒙古自治区交通运输厅<br/>
                        关于印发加快推进道路货运车辆<br/>
                        综合性能检测联网实现普通货物运输车辆<br/>
                        异地检测工作实施方案的通知
                    </div>
                    <div style="text-align: center; margin-bottom: 30px">
                        内蒙古自治区加快推进<br/>
                        道路货运车辆综合性能检测联网<br/>
                        实现普通货物运输车辆异地检测工作实施方案
                    </div>
                </div>
                <a class="download" target="_blank" href="http://www.qichezongjian.com/detect/admin/downloadAnnouncement?announcementId=3">
                    <div @mouseover="showDownload">
                        <i class="el-icon-download el-icon"></i>
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'announcement',
        data () {
            return {

            }
        },
        methods: {
            showDownload (event) {
                console.log(event.path[1].attributes)
            }
        }
    }
</script>

<style scoped lang="stylus">
#announcement {
    width: 1240px;
    margin: 0 auto;
    padding: 20px;
    .item {
        width: 360px;
        height: 500px;
        box-shadow: 0px 0px 8px 0px rgba(145, 142, 142, 1);
        padding: 0 20px;
        position: relative;
        margin-bottom: 20px;
        .header {
            border-bottom: 2px solid red;
            text-align center;
            padding: 10px;
        }
        .body {
            padding: 20px;
            text-align left
            position: relative;
        }
        .title {
            font-size: 20px;
            font-weight: bold;
            &.red {
                color: red;
            }
        }
        .tip {
            margin-top: 15px;
            font-size: 14px;
        }
        a.download {
            div {
                position: absolute;
                bottom: 10px;
                right: 10px;
                height: 40px;
                width: 40px;
                background #ccc;
                opacity 0.3
                cursor: pointer;

                i {
                    font-size: 40px;
                }
            }
            &:hover {
                div {
                    opacity 1
                }
            }
        }
    }
}
</style>